import { ArrowLeftIcon } from '@radix-ui/react-icons';
import { Flex, Heading, IconButton } from '@radix-ui/themes';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';

interface IProps {
  label: string;
  onBack?: () => void;
}

export const CommonStepHeader = (props: IProps) => (
  <Flex gap="2" align="center">
    {props.onBack && (
      <IconButton
        size="1"
        color={RADIX.COLOR.NEUTRAL}
        variant={RADIX.BUTTON.VARIANT.SECONDARY}
        onClick={props.onBack}
      >
        <ArrowLeftIcon />
      </IconButton>
    )}
    <Heading size="4">{t(props.label)}</Heading>
  </Flex>
);
